import { render, staticRenderFns } from "./FreeBundles.vue?vue&type=template&id=63b2a47a&scoped=true"
import script from "./FreeBundles.vue?vue&type=script&lang=js"
export * from "./FreeBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2a47a",
  null
  
)

export default component.exports